import React from 'react'
import New from './New'
import Doi from './Doi'

const components = {
  new: New,
  doi: Doi
};

const Success = ({isDoi, containerName}) => {
  const Success = isDoi ? components['doi'] : components['new']
  return <Success containerName={containerName}/>;
}

export default Success
